import { Languages } from 'lucide-react';
import { LANGUAGES, language, setLanguage, t } from '@/lib/i18n';

/** Two-button language toggle; choosing a language saves it and reloads the page. */
export function LanguageSwitcher({ tone = 'light' }: { tone?: 'light' | 'dark' }) {
  const dark = tone === 'dark';
  return (
    <fieldset className="flex items-center gap-2">
      <legend className="sr-only">{t('Language')}</legend>
      <Languages aria-hidden="true" className="size-4 shrink-0 text-slate-400" />
      <div
        className={`inline-flex rounded-md p-0.5 text-xs font-medium ${dark ? 'bg-white/10' : 'bg-slate-100 ring-1 ring-slate-200'}`}
      >
        {LANGUAGES.map(({ code, label }) => {
          const current = code === language;
          return (
            <button
              key={code}
              type="button"
              lang={code}
              aria-pressed={current}
              onClick={() => {
                if (!current) setLanguage(code);
              }}
              className={`rounded px-2 py-0.5 transition-colors ${
                current
                  ? dark
                    ? 'bg-white text-brand-900'
                    : 'bg-white text-brand-900 shadow-sm'
                  : dark
                    ? 'text-slate-300 hover:text-white'
                    : 'text-slate-500 hover:text-slate-800'
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
